<div style="height: calc(99% - 24px);">
  <jqxGrid #grid [theme]="theme" [width]="'99%'" [height]="'99%'" [source]="dataAdapter" [localization]="langGrid"
    [columns]="columns" [showrowlines]="false" [filterable]="true" [filter]="filter" [appCellClick]
    [showcolumnlines]="true" [pageable]="false" [sortable]="true" [altrows]="true" [groupable]="true"
    [enablebrowserselection]="true" [rowsheight]="20" [columnsheight]="20" [groupsheaderheight]="25" [editable]="false"
    [updatefilterconditions]="updatefilterconditions" (onRowclick)="onRowclick($event)">
  </jqxGrid>
</div>

<div #formEdificiosEntradasSalidas></div>